import { render, staticRenderFns } from "./StepperItem.vue?vue&type=template&id=5856bcf8&scoped=true&"
import script from "./StepperItem.vue?vue&type=script&lang=js&"
export * from "./StepperItem.vue?vue&type=script&lang=js&"
import style0 from "./StepperItem.vue?vue&type=style&index=0&id=5856bcf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5856bcf8",
  null
  
)

export default component.exports